import { render, staticRenderFns } from "./EditGardenPlan.vue?vue&type=template&id=45d30bbc&scoped=true"
import script from "./EditGardenPlan.vue?vue&type=script&lang=js"
export * from "./EditGardenPlan.vue?vue&type=script&lang=js"
import style0 from "./EditGardenPlan.vue?vue&type=style&index=0&id=45d30bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d30bbc",
  null
  
)

export default component.exports